import { FelaCSS, FelaCSSWithCustomSelectors, colors } from '@bridebook/ui';

interface IStyles {
  item: FelaCSS;
  value: FelaCSS;
  iconWell: FelaCSSWithCustomSelectors;
}

const styles = (): IStyles => ({
  item: {
    display: 'block',
    fontDefault: 14,
    lineHeight: '20px',
    color: colors.space,

    ':first-of-type': {
      marginTop: '8px',
    },
  },

  value: {
    display: 'inline',
    marginLeft: '5px',
    fontDefaultSemiBold: 'inherit',
  },

  iconWell: {
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: '20px',
    height: '20px',
    borderRadius: '100%',
    backgroundColor: colors.indigoCrush,
    color: colors.indigoCrush,

    '> div': {
      '> svg': {
        '> path': {
          fill: colors.indigoCrush10,
        },
      },
    },
  },
});

export default styles;
